export { default as MicroFrontEndEmbed } from './MicroFrontEndEmbed';
